import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { EGButton } from "../../../MainComponents/Button/EGButton/EGButton";
import { useTranslation } from "react-i18next";

export const UnsavedChanges = ({
  open,
  onClose,
  onConfirm,
  onCancel,
  title,
  titleColor,
  message,
  cancelLabel,
  confirmLabel,
  cancelColor,
  confirmColor,
}) => {
  const [t] = useTranslation("components");
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography
          component="span"
          color={titleColor || "error"}
          fontWeight={700}
          fontSize={24}
        >
          {title || t("ConfirmationModal.unsaved_changes")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography
            component="span"
            fontWeight={500}
            fontSize={16}
            color="textPrimary"
          >
            {message || t("ConfirmationModal.you_have_unsaved_changes")}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1 }}>
        <EGButton
          label={cancelLabel || t("ConfirmationModal.keep_editing")}
          onClick={onCancel || onClose}
          color={cancelColor || "primary"}
          borderColor="white"
          variant="outlined"
          size="medium"
        />
        <EGButton
          label={confirmLabel || t("ConfirmationModal.leave")}
          onClick={onConfirm}
          color={confirmColor || "secondary"}
          size="medium"
        />
      </DialogActions>
    </Dialog>
  );
};
